import React from 'react';
import { HelpSectionContainer, ModalWrapper } from './Style';
import { HELP_CENTER_LABEL } from '../../utils/constants';
import CommonButton from '../../../../components/common-button/CommonButton';
import { ExistingTicketModalProps } from '../../utils/types';
import { BLUE_EMAIL_ICON, NEW_CLOSE_ICON } from '@Images';

export const ExistingTicketModal = (
  props: ExistingTicketModalProps
): React.ReactElement<ExistingTicketModalProps> => {
  const { onClose, filteredTicket, handleViewTicket } = props;

  return (
    <ModalWrapper>
      <HelpSectionContainer id="existing-transaction">
        <img
          width={24}
          height={24}
          src={NEW_CLOSE_ICON}
          alt="close"
          className="closeIcon"
          onClick={() => {
            onClose(false);
          }}
        />
        <img className="error-image" src={BLUE_EMAIL_ICON} alt="error-icon" width={60} />
        <p className="heading-bold">{HELP_CENTER_LABEL.reminderPopup.heading}</p>
        <p className="heading">{HELP_CENTER_LABEL.reminderPopup.description}</p>
        <div className="btn-wrapper">
          <CommonButton
            text={HELP_CENTER_LABEL.reminderPopup.viewTicket}
            width={303}
            height={46}
            onClick={() => handleViewTicket(onClose, filteredTicket)}
          />
        </div>
      </HelpSectionContainer>
    </ModalWrapper>
  );
};
